/**
 * Stream & Poll Abort Managers
 *
 * Module-level state for cancelling active stream and poll operations.
 * Kept outside Redux because AbortController/functions are non-serializable.
 */

// ============================================
// Stream Abort Manager
// ============================================

let currentAbortFn: (() => void) | null = null;

export function registerStreamAbortFn(abortFn: () => void): void {
  currentAbortFn = abortFn;
}

export function clearStreamAbortFn(): void {
  currentAbortFn = null;
}

/**
 * Abort the current streaming request if one exists.
 * Returns true if an abort was triggered.
 */
export function abortCurrentStream(): boolean {
  if (currentAbortFn) {
    currentAbortFn();
    currentAbortFn = null;
    return true;
  }
  return false;
}

// ============================================
// Poll Abort Manager
// ============================================

let currentPollAbortController: AbortController | null = null;

/**
 * Register an AbortController for the current polling operation.
 * Aborts any existing poll before registering the new one.
 */
export function registerPollAbortController(controller: AbortController): void {
  if (currentPollAbortController) {
    currentPollAbortController.abort();
  }
  currentPollAbortController = controller;
}

export function abortCurrentPoll(): void {
  if (currentPollAbortController) {
    currentPollAbortController.abort();
    currentPollAbortController = null;
  }
}
